<template>
  <div>
    <h1 class="headline font-weight-medium grey--text my-2">Recuperação de Senha</h1>

    <v-form class="px-12" ref="form" lazy-validation>
        <h1 class="text-center subtitle-1 font-weight-medium grey--text my-2">
          Digite o e-mail associado com a sua conta e, em seguida, será enviado um código de verificação
        </h1>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        type="email"
        label="E-mail"
        outlined
      ></v-text-field>
      <v-container>
        <v-layout row wrap>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            to="/"
          >Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            @click="sendToEmail"
          >Enviar</v-btn>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
    name:"ForgotPassword",
    data:()=>({
        email: "",
        password: "",
        emailRules: [
            (v) => !!v || "Necessário preencher o E-mail!",
            (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "E-mail inválido!",
        ],
        passwordRules: [(v) => !!v || "Necessário preencher a senha!"],
    }),
    mounted() {
        window.addEventListener('keydown', this.handleEnter)
    },
    destroyed() {
        window.removeEventListener('keydown', this.handleEnter)
    },
    methods:{
        handleEnter(e) {
            if (e.key === 'Enter') {
                this.sendToEmail()
            }
        },
        sendToEmail() {
            if(this.$refs.form.validate()){
                /* this.$store.dispatch("sendEmailRecovery", {
                    email: this.email
                }); */
                console.log('Daqui é só enviar')
                this.$router.push('recuperarsenha')
            }
        },
    }
};
</script>

<style>
</style>